import React, { Component } from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

class DetailsNav extends Component {

    handleReloadParent = () => {
        this.props.onLoadParent(this.props.parent);
    }

    render() { 
        return ( 
            <div style={{ padding: '8px 12px', display: 'flex', justifyContent: 'flex-start' }}>
                <IconButton 
                    onClick={this.handleReloadParent}
                    size="small"
                    color="default"
                >
                    <ArrowBackIcon />
                </IconButton>
            </div>
        );
    }
}
 
export default DetailsNav;